/**
 * Reusable custom amount input with dollar prefix, validation error display.
 * Used in both the top-up modal and split view top-up content.
 */
import type { ReactNode } from 'react'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

export interface BillingCustomAmountInputProps {
  id: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  error: string | null
  inputClassName?: string
  className?: string
}

export const BillingCustomAmountInput: React.FC<BillingCustomAmountInputProps> = ({
  id,
  value,
  onChange,
  error,
  inputClassName,
  className,
}): ReactNode => (
  <div className={cn('flex flex-col gap-2', className)}>
    <Label htmlFor={id} className="text-sm">
      Custom amount
    </Label>
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">$</span>
      <Input
        id={id}
        type="text"
        inputMode="numeric"
        placeholder="Enter amount"
        value={value}
        onChange={onChange}
        className={cn('pl-7', inputClassName, error && 'border-destructive')}
      />
    </div>
    {error && <p className="text-sm text-destructive">{error}</p>}
  </div>
)
